import { ReactElement } from "react";
import { Navigate, Routes, Route } from "react-router-dom";

import { initializeLocalForage } from "./data/storage";
import Gallery from "./components/Gallery";
import Edit from "./components/Edit";
import Shortcuts from "./components/Shortcuts";
import Settings from "./components/Settings";
import { useBlockContextMenu } from "./lib/dom";

export default function App(): ReactElement {
  initializeLocalForage();
  useBlockContextMenu();

  // TODO: Make transitions between routes nice. Blocked on
  // https://github.com/ReactTraining/react-router/pull/7298 and stable
  // react-router v6 release.
  return (
    <>
      <Routes>
        <Route path="/" element={<Gallery />} />
        <Route path="edit/:id" element={<Edit />} />
        <Route path="edit/shortcuts" element={<Shortcuts />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Navigate to={"/"} replace={true} />} />
      </Routes>
    </>
  );
}
